import { CircularProgress } from "@material-ui/core";

export const getButtonIcon = (isFormSubmitting) => {
  if (isFormSubmitting) {
    return <CircularProgress color="inherit" size={20} />;
  }
};

export const getButtonText = (
  isFormSubmitting,
  isNewManualDataEntry = false
) => {
  if (isFormSubmitting) {
    if (isNewManualDataEntry) {
      return "Creating";
    } else {
      return "Saving";
    }
  }
  if (isNewManualDataEntry) {
    return "Create";
  } else {
    return "Save";
  }
};
